import React from 'react'
import MUICheckbox, {CheckboxProps as MUICheckboxProps} from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

/**
 * Props to use when instantiating a `Checkbox` component.
 */
export interface CheckboxProps extends MUICheckboxProps {
  /**
   * Disable the button.
   */
  disabled?: boolean,

  /**
   * Optional label 
   */
  label?: string,

  /**
   * Optional label placement 
   */
  labelPlacement?: 'top' | 'start' | 'bottom' | 'end',

  /**
   * Optional value 
   */
  value?: string,

  /**
   * Optional custom color 
   */
  customColor?: string,
}

/**
 * A checkbox component that be used as a controlled or uncontrolled component.
 * 
 */
export function Checkbox({
  disabled = false,
  label,
  labelPlacement = "end",
  value,
  customColor,
  ...checkboxProps
}: MUICheckboxProps & CheckboxProps){
  const checkbox = <MUICheckbox 
    disabled={disabled}
    sx={customColor ? {
      color: customColor,
      '&.Mui-checked': {
        color: customColor,
      },
    }: {}}
    {...checkboxProps} 
  />

  if (label) {
    return <FormControlLabel
    value={value}
    control={checkbox}
    label={label}
    labelPlacement={labelPlacement}
  />
  }

  return checkbox;
}
